import { useEffect, useState } from "react";
import {
    useMutation
} from "react-query";
import { httpGET } from "../../utils/ajaxHelper";
import AGButton from "../Button";

import { FieldArray, Formik, FormikProps } from "formik";
import { useContext, useRef } from "react";
import AGSelect from "../../components/AgSelect";
import {
    Address,
    AgnetRegion,
    ComMainService,
    CompracticeLevel,
    FirmAddress,
    Individual,
} from "../../models";

import { UserContext } from "../../Provider";
import Button from "../../components/Button";
import { httpPOST } from "../../utils/ajaxHelper";
import {
    CommerceCompassStyled,
    CustomBackground,
    StyledDatePickerCus
} from "./modalAddService.styled";

import moment from "moment";
import { useParams } from "react-router-dom";
import { CommerceProductSchema } from "../../Schema/CommerceCompassSchema";
import AGCheckbox from "../../components/Checkbox";
import AGInput from "../../components/Input";
import { default as AGTextarea, default as AGtextarea } from "../../components/Textarea";
import { ADMIN_ORGANIZATION, MODAL_CONSTANT } from "../../utils/constant";
import { AddIconDatePicker } from "../AddIconDatePicker";
import AGModal from "../Modal";
import { useNotification } from "../Notification";
import { RolesHandle, RolesHandleAdmin } from "../RolesHandle";
import Tooltip from "../Tooltip";
import { GlobalStyle } from "../ModalAddService/modalAddService.styled";
import { handleNumericDateInput } from "../../utils/helper";


export interface AddProductModalProps {
    visible: boolean;
    toggleModal: () => void;
    submitComplete: () => void;
}
const AddProductModal = ({
    visible,
    toggleModal,
    submitComplete
}: AddProductModalProps) => {
    const handleClose = () => {
        toggleModal();
    };
    const { showNotification } = useNotification();
    const [submitCount, setSubmitCount] = useState<number>(0);
    const { id } = useParams();
    const [agnetRegion, setAgnetRegion] = useState<AgnetRegion[]>();
    const [addAgnetRegion, setAddAgnetRegion] = useState<AgnetRegion[]>();
    const [firmAddresses, setFirmAddresses] = useState<Address[]>();
    const [comMainService, setComMainService] = useState<ComMainService[]>([]);
    const [individual, setIndividual] = useState<Individual[]>();

    const [expertiseServices, setExpertiseServices] = useState<any>();
    const formRef = useRef<FormikProps<any>>(null);
    const componentRef = useRef<HTMLDivElement>(null);
    const user = useContext(UserContext);
    const [, setCompracticeLevel] =
        useState<CompracticeLevel[]>();
    const [submitType, setSubmitType] = useState<"Draff" | "Publish" | undefined>(undefined);
    const [selectedDate, setSelectedDate] = useState(undefined);

    const { mutate: getAgnetRegion } = useMutation(
        (firmId: number | undefined) =>
            httpGET({
                url: "/agnetregion",
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setAgnetRegion(rs as AgnetRegion[]);
            },
        },
    );
    const { mutate: getAddEditAgnetRegion } = useMutation(
        (firmId: number | undefined) =>
            httpGET({
                url: "/agnetregion/add-edit",
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setAddAgnetRegion(rs as AgnetRegion[]);
            },
        },
    );

    const { mutate: getIndividuals } = useMutation(
        (id: number) =>
            httpGET({
                url: "/Individuals",
                params: { id },
            }),
        {
            onSuccess: (rs) => {
                setIndividual(rs as Individual[]);
            },
        },
    );

    const { mutate: getCompracticeLevel } = useMutation(
        () =>
            httpGET({
                url: "/compracticeLevel",
            }),
        {
            onSuccess: (rs) => {
                setCompracticeLevel(rs as CompracticeLevel[]);
            },
        },
    );

    const { mutate: getComMainServices } = useMutation(
        () =>
            httpGET({
                url: "/ComMainService",
                params: { type: "PRODUCT" }
            }),
        {
            onSuccess: (rs) => {
                setComMainService(rs as ComMainService[]);
            },
        },
    );

    const { mutate: getFirmAddresses } = useMutation(
        (par: any) =>
            httpGET({
                url: "/firm/firm-addresses",
                params: { ...par },
            }),
        {
            onSuccess: (rs) => {
                setFirmAddresses(rs as FirmAddress[]);
            },
        },
    );
    const { mutate: submitForm, isLoading: isLoadingSubmitForm } = useMutation(
        (data: FormData) =>
            httpPOST({
                url: "/CommerceFirmData/product",
                data: data,
            }),
        {
            onSuccess: (rs) => {
                handleClose();
                formRef.current?.resetForm();
                setSubmitCount(0);
                if (submitType === 'Draff') {
                    handleClose();
                } else {
                    submitComplete();
                }
                setSubmitType(undefined);
            },
            onError: (rs: any) => {
                showNotification(rs.message, "Error");
            }
        },
    );


    const { mutate: getServices } = useMutation(
        (firmId: number) =>
            httpGET({
                url: `/ExpertiseService/product?firmId=${firmId}`
            }),
        {
            onSuccess: (rs) => {
                setExpertiseServices(rs)
            },
            onError: (rs: any) => {
                showNotification(rs.message, "Error");
            }
        },
    );


    useEffect(() => {
        getFirmAddresses({ id: user!.firmAddress?.netRegion, firmId: Number(id) });
        getIndividuals(Number(id));
        getAgnetRegion(user?.individual?.fkOrgId);
        getAddEditAgnetRegion(user?.individual?.fkOrgId);
        getComMainServices();
        getCompracticeLevel();
        getServices(Number(id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getAgnetRegion,
        getComMainServices,
        getCompracticeLevel,
        visible,
        Number(id)
    ]);

    useEffect(() => {
        if (submitType !== undefined && !isLoadingSubmitForm) {
            formRef.current?.submitForm();
            setSubmitCount(submitCount + 1);
            setSubmitType(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitType]);

    if (!agnetRegion || !id || !firmAddresses) {
        return null;
    }

    const regionId = firmAddresses?.find(e => e.fkOrgId === Number(id))?.netRegion;
    return (
        <AGModal
            toggleModal={() => {
                toggleModal();
                setSubmitCount(0);
                setSelectedDate(undefined);
            }}
            title="Add Product"
            footer={<div className="flex !touch-none gap-[10px]"> <AGButton
                type="Primary"
                onClick={() => {
                    if (!isLoadingSubmitForm) {
                        setSubmitType("Draff")
                    }
                }}>
                Save Draft
            </AGButton>
                <AGButton
                    type="Success"
                    onClick={() => {
                        if (!isLoadingSubmitForm) {
                            setSubmitType("Publish")
                        }
                    }}
                >
                    Publish
                </AGButton></div>}
            visible={visible}
            toolstip={true}
            titleTooltip={MODAL_CONSTANT.ADD_PRODUCT}
        >
            <CustomBackground ref={componentRef}>
                <CommerceCompassStyled>
                    <div className="print">
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={CommerceProductSchema}
                                initialValues={
                                    {
                                        country: {
                                            value: firmAddresses?.findIndex(
                                                (e) => e.fkOrgId === Number(id),
                                            ),
                                            label:
                                                firmAddresses?.find(
                                                    (e) => e.fkOrgId === Number(id),
                                                )?.firmName1 +
                                                " - " +
                                                firmAddresses?.find(
                                                    (e) => e.fkOrgId === Number(id),
                                                )?.country,
                                            fkOrgId: Number(id),
                                        },
                                        region: {
                                            value: agnetRegion?.find(
                                                (e) => e.netRegionId === regionId,
                                            )?.netRegionId,
                                            label: agnetRegion?.find(
                                                (e) => e.netRegionId === regionId,
                                            )?.netRegionName,
                                        },
                                        today: new Date(),
                                        keyContact: [],
                                        locationServices: [],
                                        firmId: id || user?.individual.fkOrgId,
                                        compracticeLevels: [
                                            {
                                                customName: "",
                                                compracticeLevel: ""
                                            }
                                        ],
                                        urlLink: "",
                                        webpageDisplayName: "",
                                        videoLink: "",
                                        startDate: undefined,
                                        endDate: undefined,
                                        sponsorMessage: "",
                                        sponsorProfile: false,
                                        memberBenefits: "",
                                        tagLine: "",
                                        title: ""
                                    } as any
                                }
                                validateOnChange={submitCount >= 1}
                                onSubmit={(values) => {

                                    if (submitType !== undefined) {
                                        const data = {
                                            fkFirmId: values.firmId,
                                            dateEntered: moment(
                                                values.today,
                                            ).toISOString(),
                                            detailedDescription: values.detailedDescription.trim() ?? "",
                                            urlLink: values.urlLink ? values.urlLink.trim() : "",
                                            webpageDisplayName: values.webpageDisplayName.trim() ?? "",
                                            region: values.region.value,
                                            videoLink: values.videoLink ? values.videoLink.trim() : "",
                                            startDate: values.startDate && values.sponsorProfile ? values.startDate.toLocaleDateString("en-US") : "",
                                            endDate: values.endDate && values.sponsorProfile ? values.endDate.toLocaleDateString("en-US") : "",
                                            sponsorMessage: values.sponsorMessage.trim() ?? "",
                                            sponsorProfile: values.sponsorProfile,
                                            memberBenefits: values.memberBenefits.trim() ?? "",
                                            comContactIds: values.keyContact.map(
                                                (e: any) => e.value,
                                            ),
                                            title: values.title.trim() ?? "",
                                            tagLine: values.tagLine.trim() ?? "",
                                            distinctPractices:
                                                values.compracticeLevelsCustom ? values.compracticeLevelsCustom
                                                    .filter((f: any) => f)
                                                    .filter(
                                                        (f: any) =>
                                                            f.customName &&
                                                            f.compracticeLevel,
                                                    )
                                                    .map((e: any) => {
                                                        return `${e.customName}___${e.compracticeLevel.value}`;
                                                    }) : [],
                                            compracticeLevels:
                                                values.compracticeLevels
                                                    .map((e: any) => {
                                                        return `${e?.secondaryServiceId.value}`;
                                                    }),
                                            locationServices:
                                                values.locationServices ? values.locationServices
                                                    .filter((f: any) => f)
                                                    .filter(
                                                        (f: any) => f.netRegionId && f.individualId
                                                    )
                                                    .map((e: any) => {
                                                        return `${e?.netRegionId.value}___${e?.individualId.filter((e: any) => e?.value !== '').map((f: any) => f.value).join(",")}`;
                                                    }) : [],
                                            globalOpportunities:
                                                values.globalOpportunities,
                                        } as any;

                                        const formData = new FormData();

                                        if (values.file) {
                                            formData.append("logo", values.file);
                                        }
                                        if (values.filePdf) {
                                            formData.append(
                                                "filePdf",
                                                values.filePdf,
                                            );
                                        }
                                        if (values.serviceLogo) {
                                            formData.append(
                                                "serviceLogo",
                                                values.serviceLogo,
                                            );
                                        }
                                        for (const key in data) {
                                            const value = data[key];

                                            if (Array.isArray(value)) {
                                                value.forEach((item: any) => {
                                                    formData.append(
                                                        `${key}`,
                                                        JSON.stringify(item),
                                                    );
                                                });
                                            } else {
                                                formData.append(key, value);
                                            }
                                        }
                                        formData.append("type", submitType);
                                        if (submitType === 'Draff') {
                                            formData.append("isDraff", JSON.stringify(true));
                                            submitForm(formData);
                                        }
                                        if (submitType === 'Publish') {
                                            formData.append("isDraff", JSON.stringify(false));
                                            submitForm(formData);
                                        }
                                    }
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    setFieldValue,
                                }) => {

                                    const optionInitialComSecondaryServices = values.mainServiceId ? comMainService?.find(
                                        (e) => e.mainServiceId === values.mainServiceId.value
                                    )?.comOfferingSecondaryServices?.map(
                                        (e) => ({
                                            value: e.secondaryServiceId,
                                            label: e.secondaryServiceName
                                        })) : [];

                                    const tblComSecondaryServices = optionInitialComSecondaryServices?.length ? optionInitialComSecondaryServices
                                        .filter(e => !values.compracticeLevels.some((f: any) => f.secondaryServiceId?.value === e.value)) : [];

                                    const createdService = expertiseServices.map((e: any) => e.mainService.mainServiceId);

                                    let messengeError = "";

                                    Object.keys(errors).forEach(function (
                                        key,
                                        index,
                                    ) {
                                        if (
                                            key === "compracticeLevelsCustom"
                                        ) {
                                            const compracticeLevelsCustom: any =
                                                errors[key];

                                            return (messengeError +=
                                                compracticeLevelsCustom.find(
                                                    (f: any) => f?.isValid,
                                                )
                                                    ? "Question 7" +
                                                    (index ===
                                                        Object.keys(errors)
                                                            .length -
                                                        1
                                                        ? "."
                                                        : ", ")
                                                    : "");
                                        }

                                        return (messengeError +=
                                            errors[key]
                                                ?.toString()
                                                .replace("_", "")
                                                .replace("+", "") +
                                            (index ===
                                                Object.keys(errors).length - 1
                                                ? "."
                                                : ", "));
                                    });
                                    return (
                                        <form>
                                            <RolesHandle firmId={ADMIN_ORGANIZATION.ID} fkOrgId={ADMIN_ORGANIZATION.ID} roles={["Admin"]}>
                                                <div>
                                                    <label
                                                        className="label-title"
                                                        htmlFor="">
                                                        Organization Region:{" "}
                                                        <span className="required">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div className="subtitle">
                                                        <span>
                                                            Please select the
                                                            Region.
                                                        </span>
                                                    </div>
                                                    <div className="custom-select">
                                                        <AGSelect
                                                            placeholder="Enter/ Select your answer"
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                getFirmAddresses({ id: e?.value as any });
                                                                setFieldValue(
                                                                    "keyContact",
                                                                    "",
                                                                );
                                                                setFieldValue(
                                                                    "region",
                                                                    e,
                                                                );
                                                                if (e) {
                                                                    setFieldValue(
                                                                        "country",
                                                                        "",
                                                                    );
                                                                }
                                                            }}
                                                            value={values.region}
                                                            options={agnetRegion?.map(
                                                                (e) => {
                                                                    return {
                                                                        value: e.netRegionId,
                                                                        label: e.netRegionName,
                                                                    };
                                                                },
                                                            )}
                                                            isDisabled={Number(id) !== ADMIN_ORGANIZATION.ID}
                                                        />
                                                        {errors.region && (
                                                            <div className="error">
                                                                This question is
                                                                required.{" "}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    <label
                                                        className="label-title"
                                                        htmlFor="">
                                                        Organization Name - Country:{" "}
                                                        <span className="required">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div className="subtitle">
                                                        <span>
                                                            Please Select Organization (Country).
                                                        </span>
                                                    </div>
                                                    <AGSelect
                                                        placeholder="Enter/ Select your answer"
                                                        value={values.country}
                                                        onChange={(
                                                            e: any,
                                                        ) => {
                                                            getIndividuals(
                                                                e?.fkOrgId as any,
                                                            );
                                                            setFieldValue(
                                                                "firmId", e?.fkOrgId,
                                                            );
                                                            setFieldValue(
                                                                "keyContact",
                                                                "",
                                                            );
                                                            setFieldValue(
                                                                "country",
                                                                e,
                                                            );
                                                            if (e) {
                                                                getServices(e.fkOrgId);
                                                            }
                                                        }}
                                                        options={firmAddresses?.map(
                                                            (
                                                                e,
                                                                index,
                                                            ) => {
                                                                return {
                                                                    value: index,
                                                                    label: e.firmName1 + " - " + e.country,
                                                                    fkOrgId: e.fkOrgId,
                                                                    disabled: e.createdProducts && e.createdProducts >= user?.individual.productMaximumQuantity! ? true : false
                                                                };
                                                            },
                                                        )}
                                                        isOptionDisabled={(option: any) => option.disabled}
                                                        isDisabled={Number(id) !== ADMIN_ORGANIZATION.ID}
                                                    />
                                                    {errors.country && (
                                                        <div className="error">
                                                            This
                                                            question is
                                                            required.{" "}
                                                        </div>
                                                    )}
                                                </div>
                                            </RolesHandle>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Key Contact(s):{" "}<span className="required">*</span>
                                                </label>
                                                <div data-tip="Tooltip content" className="subtitle">
                                                    Select a maximum of 3 key contacts. If a key contact for your organization isn’t listed, ask your organization’s AG Champion to get them added to our database.
                                                </div>
                                                <AGSelect
                                                    placeholder="Enter/ Select your answer"
                                                    value={
                                                        values.keyContact
                                                    }
                                                    onChange={(
                                                        e: any,
                                                    ) => {
                                                        if (e.length > 3) {
                                                            setFieldValue(
                                                                "keyContact",
                                                                e.slice(
                                                                    1,
                                                                    4,
                                                                ),
                                                            );
                                                        } else {
                                                            setFieldValue(
                                                                "keyContact",
                                                                e,
                                                            );
                                                        }
                                                    }}
                                                    options={individual?.sort((a, b) => ((a.firstName +
                                                        " " + a.lastName) > (b.firstName + " " + b.lastName)) ? 1
                                                        : ((b.firstName + " " +
                                                            b.lastName) > (a.firstName +
                                                                " " +
                                                                a.lastName) ? -1 : 0))
                                                        .map(
                                                            (e) => {
                                                                return {
                                                                    value: e.individualId,
                                                                    label:
                                                                        e.firstName +
                                                                        " " +
                                                                        e.lastName,
                                                                };
                                                            },
                                                        )}
                                                    isMulti
                                                />
                                                {errors.keyContact && (
                                                    <div className="error">
                                                        This question is required.
                                                    </div>
                                                )}
                                            </div>
                                            {/* {Object.keys(errors).length >
                                                0 &&
                                                messengeError && (
                                                    <div className="error">
                                                        {
                                                            Object.keys(
                                                                errors,
                                                            ).length
                                                        }{" "}
                                                        question(s) need to
                                                        be completed:{" "}
                                                        {messengeError}
                                                    </div>
                                                )} */}

                                            {/* Location service*/}
                                            <FieldArray
                                                name="locationServices"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        <label
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "start"
                                                            }}
                                                            className="label-title"
                                                            htmlFor="">
                                                            <div className="wraptitle">
                                                                Region Contact(s):
                                                                <Tooltip text={<div className="tool-tip">
                                                                    Key contacts are required, but if there are region-specific contacts for better connectivity, please list them here (optional).
                                                                </div>
                                                                } />
                                                            </div>
                                                        </label>

                                                        <div data-tip="Tooltip content" className="subtitle flex">
                                                            Select a maximum of 3 key contacts for each region. If a key contact for your organization isn’t listed, ask your organization’s AG Champion to get them added to our database.
                                                            <Button
                                                                type="Link"
                                                                icon={<PlusIcon />}
                                                                onClick={() =>
                                                                    arrayHelpers.push(
                                                                        {
                                                                            netRegionId: "",
                                                                            individualId: "",
                                                                        },
                                                                    )
                                                                }
                                                                disabled={addAgnetRegion ? values.locationServices.length >= addAgnetRegion?.length : true}
                                                            >
                                                                <div className="add-new">Add new</div>
                                                            </Button>
                                                        </div>
                                                        {values.locationServices &&
                                                            values.locationServices.length > 0 && (
                                                                values.locationServices.map((e: any, index: number,) => (
                                                                    <div
                                                                        className="w-full flex mb-[15px]"
                                                                        key={index}>
                                                                        <div className="w-[25%]">
                                                                            <AGSelect
                                                                                placeholder="Choose region"
                                                                                value={values.locationServices[index].netRegionId}
                                                                                onChange={(f: any) => {
                                                                                    setFieldValue(`locationServices.${index}.netRegionId`, f);
                                                                                }}
                                                                                options={addAgnetRegion?.filter(f =>
                                                                                    f.netRegionId &&
                                                                                    !values.locationServices.some((k: any) => k.netRegionId.value === f.netRegionId)
                                                                                ).map((e) => {
                                                                                    return {
                                                                                        value: e.netRegionId,
                                                                                        label: e.netRegionName,
                                                                                    };
                                                                                })}
                                                                            />
                                                                            <div className="error">
                                                                                {!values.locationServices[index].netRegionId && values.locationServices[index].individualId && " This question is required."}
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex flex-1 min-w-0 ml-2">
                                                                            <div className="flex-1 min-w-0">
                                                                                <AGSelect
                                                                                    // isSearchable={false}
                                                                                    placeholder="Choose contact(s)"
                                                                                    value={values.locationServices[index].individualId}
                                                                                    onChange={(f: any) => {

                                                                                        if (Array.isArray(f) && f.length === 0) {
                                                                                            setFieldValue(
                                                                                                `locationServices.${index}.individualId`,
                                                                                                undefined,
                                                                                            );
                                                                                            return;
                                                                                        }

                                                                                        if (f.length > 3) {
                                                                                            setFieldValue(
                                                                                                `locationServices.${index}.individualId`,
                                                                                                f.slice(
                                                                                                    1,
                                                                                                    4,
                                                                                                ),
                                                                                            );
                                                                                        } else {
                                                                                            setFieldValue(
                                                                                                `locationServices.${index}.individualId`,
                                                                                                f,
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    options={individual?.sort((a, b) => ((a.firstName +
                                                                                        " " + a.lastName) > (b.firstName + " " + b.lastName)) ? 1
                                                                                        : ((b.firstName + " " +
                                                                                            b.lastName) > (a.firstName +
                                                                                                " " +
                                                                                                a.lastName) ? -1 : 0))
                                                                                        .map(
                                                                                            (e) => {
                                                                                                return {
                                                                                                    value: e.individualId,
                                                                                                    label:
                                                                                                        e.firstName +
                                                                                                        " " +
                                                                                                        e.lastName,
                                                                                                };
                                                                                            },
                                                                                        )}
                                                                                    isMulti
                                                                                />
                                                                                <div className="error">
                                                                                    {!values.locationServices[index].individualId && values.locationServices[index].netRegionId && " This question is required."}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex-shrink-0 ml-2">
                                                                                <AGButton
                                                                                type="Primary"
                                                                                style={{
                                                                                    borderRadius: 5,
                                                                                    opacity: values.locationServices.length === 0 ? 0.2 : 1,
                                                                                    border: "1px solid",
                                                                                    color: "#2c76aa",
                                                                                    borderColor: "#2c76aa",
                                                                                    background: "transparent",
                                                                                    height: "38px",
                                                                                    width: "38px"
                                                                                }}
                                                                                disabled={values.locationServices.length === 0}
                                                                                onClick={() =>
                                                                                    arrayHelpers.remove(
                                                                                        index,
                                                                                    )
                                                                                }>
                                                                                <MinusIcon />
                                                                            </AGButton>
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                )))
                                                        }
                                                    </div>
                                                )}
                                            />

                                            <div className="w-full pb-[15px]">
                                                <label className="label-title">
                                                    Product Name:
                                                    <span className="required"> *</span>
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            A short name that clearly identifies your product and does not exceed 100 characters.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={100}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    value={values.title}
                                                    onChange={(e) => {
                                                        setFieldValue("title", e.target.value)
                                                    }}
                                                />
                                                {errors.title && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Specialized Product:{" "}
                                                    <span className="required">
                                                        {" "}
                                                        *
                                                        <Tooltip text={<div className="tool-tip">
                                                            Select a specialized product area to feature.
                                                            Complete and submit another Commerce Product Profile for any additional specialized products you wish to feature.
                                                            If you would like to feature a specialized product area that is not listed,
                                                            please email <a
                                                                href={`mailto:${process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                                                    "techsupport@allinialglobal.com"
                                                                    }`}
                                                                className="linkified">
                                                                {process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                                                    "techsupport@allinialglobal.com"}
                                                            </a> to request it to be added.
                                                        </div>
                                                        } />
                                                    </span>
                                                </label>
                                                <div>
                                                    <AGSelect
                                                        placeholder="Enter/ Select Specialized Product"
                                                        value={values.mainServiceId}
                                                        onChange={(e: any) => {
                                                            setFieldValue("mainServiceId", e);
                                                            setFieldValue("compracticeLevels", [{
                                                                compracticeLevel: "",
                                                                secondaryServiceId: "",
                                                            }]);
                                                        }}
                                                        options={comMainService?.sort((a, b) => a.mainServiceName!.localeCompare(b.mainServiceName!))
                                                            .map(
                                                                (e) => {
                                                                    return {
                                                                        value: e.mainServiceId,
                                                                        label: e.mainServiceName,
                                                                        disabled: createdService.some((f: number) => f === e.mainServiceId)
                                                                    };
                                                                },
                                                            )}
                                                        isOptionDisabled={(option: any) => option.disabled} />
                                                </div>
                                                {errors.mainServiceId && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            {/* compractice level*/}
                                            <FieldArray
                                                name="compracticeLevels"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        <label
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "start"
                                                            }}
                                                            className="label-title"
                                                            htmlFor="">
                                                            <div className="wraptitle">
                                                                Product Category:<span className="required">{" "}*
                                                                    <Tooltip text={
                                                                        <div className="tool-tip">
                                                                            Select the various product category your organization has within the specialized
                                                                            product area.
                                                                        </div>
                                                                    } />
                                                                </span>
                                                            </div>

                                                        </label>
                                                        <div data-tip="Tooltip content" className="subtitle flex">
                                                            Select at least 1 product category.
                                                            <Button
                                                                type="Link"
                                                                icon={<PlusIcon />}
                                                                onClick={() =>
                                                                    arrayHelpers.push(
                                                                        {
                                                                            compracticeLevel: "",
                                                                            secondaryServiceId: "",
                                                                        },
                                                                    )
                                                                }
                                                                disabled={optionInitialComSecondaryServices ? values.compracticeLevels.length >= optionInitialComSecondaryServices?.length : true}
                                                            >
                                                                <div className="add-new">Add new</div>
                                                            </Button>
                                                        </div>
                                                        {values.compracticeLevels.map((e: any, index: number,) => (
                                                            <div
                                                                className="form-item-custom"
                                                                key={index}>
                                                                <div className="custom-select">
                                                                    <AGSelect
                                                                        placeholder="Choose product category"
                                                                        value={values.compracticeLevels[index].secondaryServiceId}
                                                                        onChange={(f: any) => {
                                                                            setFieldValue(`compracticeLevels.${index}.secondaryServiceId`, f);
                                                                        }}
                                                                        options={tblComSecondaryServices}
                                                                    />
                                                                    {/* <div className="error">
                                                                        {!values.compracticeLevels[index].compracticeLevel &&
                                                                            values.compracticeLevels[index].secondaryServiceId &&
                                                                            " This question is required."}
                                                                    </div> */}
                                                                </div>
                                                                <div className="wraper-right">
                                                                    <AGButton
                                                                        type="Primary"
                                                                        style={{
                                                                            borderRadius: 5,
                                                                            opacity: values.compracticeLevels.length === 1 ? 0.2 : 1,
                                                                            border: "1px solid",
                                                                            color: "#2c76aa",
                                                                            borderColor: "#2c76aa",
                                                                            background: "transparent"
                                                                        }}
                                                                        disabled={values.compracticeLevels.length === 1}
                                                                        onClick={() =>
                                                                            arrayHelpers.remove(
                                                                                index,
                                                                            )
                                                                        }>
                                                                        <MinusIcon />
                                                                    </AGButton>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {errors.compracticeLevels && (
                                                            <div className="error">
                                                                This question is
                                                                required.
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            />

                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Product Logo:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Please upload a product logo photo with a preferred size of 280x180px and should not exceed 0.5MB. Image file type must be .jpg,.jpeg,.png,.gif,.webp
                                                        </i>
                                                    </span>
                                                </div>

                                                <div className="wraper-removeButton">
                                                    {values.serviceLogo?.name && (
                                                        <AGButton
                                                            onClick={() => {
                                                                setFieldValue(
                                                                    "isServiceLogo",
                                                                    true,
                                                                );
                                                                setFieldValue(
                                                                    "serviceLogo",
                                                                    undefined,
                                                                );
                                                            }}
                                                            type="Secondary">
                                                            Remove Logo
                                                        </AGButton>
                                                    )}
                                                    <label className="lable-upload">
                                                        <input
                                                            id="upload-photo"
                                                            name="serviceLogo"
                                                            accept="image/*"
                                                            type="file"
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            key={values.serviceLogo}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    "serviceLogo",
                                                                    e
                                                                        .currentTarget
                                                                        .files?.[0]
                                                                        ? e
                                                                            .currentTarget
                                                                            .files[0]
                                                                        : "",
                                                                );
                                                                setFieldValue(
                                                                    "isServiceLogo",
                                                                    false,
                                                                );
                                                            }}
                                                        />

                                                        {!values.serviceLogo
                                                            ?.name && (
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                <a
                                                                    style={{
                                                                        color: "#2C76AA",
                                                                        textDecoration: "underline",
                                                                    }}>
                                                                    + Upload logo
                                                                </a>
                                                            )}
                                                        <span className="upload-name">
                                                            {
                                                                values.serviceLogo
                                                                    ?.name
                                                            }
                                                        </span>
                                                    </label>
                                                </div>
                                                {errors.serviceLogo && (<div className="error">
                                                    {errors.serviceLogo.toString()}
                                                </div>
                                                )}
                                            </div>
                                            <div className="w-full pb-[15px]">
                                                <label className="label-title">
                                                    Product Tag Line:
                                                    <span className="required"> *</span>
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            A brief phrase that creates a lasting impression about your product. </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={150}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    value={values.tagLine}
                                                    onChange={(e) => {
                                                        setFieldValue("tagLine", e.target.value)
                                                    }}
                                                />
                                                {errors.tagLine && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Video Link:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            <span>
                                                                If the organization has a relevant marketing video, provide the URL/ YouTube.
                                                            </span>
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={255}
                                                    placeholder="Enter Video URL"
                                                    className="custom-input"
                                                    value={values.videoLink}
                                                    onChange={(e) => {
                                                        setFieldValue("videoLink", e.target.value)
                                                    }}
                                                />
                                                {errors.videoLink && (
                                                    <div className="error">
                                                        Please enter a valid
                                                        URL.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label className="label-title">
                                                    Product Detailed Description:
                                                    <span className="required"> *
                                                        <Tooltip text={<div className="tool-tip">Up to 2000 characters concisely describing the product line and distinct product category for this submission. Showcase important points about your organization in an intriguing way. Give recent project and client success examples that substantiate expertise and experience.</div>} />
                                                    </span>
                                                </label>
                                                <AGtextarea
                                                    maxLength={1999}
                                                    placeholder="Enter your answer"
                                                    className="text-area"
                                                    onChange={(e) => {
                                                        setFieldValue("detailedDescription", e.target.value)
                                                    }}
                                                />
                                                {errors.detailedDescription && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Product URL:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Please provide a URL to the organization’s webpage where the specialized product
                                                            and distinct product category are further described.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={255}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    onChange={(e) => {
                                                        setFieldValue("urlLink", e.target.value);
                                                        if (!e.target.value?.trim()) {
                                                            setFieldValue("webpageDisplayName", "")
                                                        }
                                                    }}
                                                />
                                                {errors.urlLink && (
                                                    <div className="error">
                                                        Please enter a valid
                                                        URL.
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ marginTop: 10 }}>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            If you prefer to display a name instead of the URL, please provide a display name for the organization's webpage.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    value={values.webpageDisplayName}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    disabled={!values.urlLink?.trim()}
                                                    onChange={(e) => {
                                                        setFieldValue("webpageDisplayName", e.target.value)
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Product Brochure:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Upload an organization brochure (pdf file) featuring the specialized product area.
                                                        </i>
                                                    </span>
                                                </div>

                                                <div className="wraper-removeButton">
                                                    {values.filePdf?.name && (
                                                        <AGButton
                                                            onClick={() => {
                                                                setFieldValue(
                                                                    "isDeletePdf",
                                                                    true,
                                                                );
                                                                setFieldValue(
                                                                    "filePdf",
                                                                    undefined,
                                                                );
                                                            }}
                                                            type="Secondary">
                                                            Remove PDF
                                                        </AGButton>
                                                    )}
                                                    <label className="lable-upload">
                                                        <input
                                                            id="upload-photo"
                                                            name="filePdf"
                                                            accept="application/pdf"
                                                            type="file"
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            key={values.filePdf}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    "filePdf",
                                                                    e
                                                                        .currentTarget
                                                                        .files?.[0]
                                                                        ? e
                                                                            .currentTarget
                                                                            .files[0]
                                                                        : "",
                                                                );
                                                                setFieldValue(
                                                                    "isDeletePdf",
                                                                    false,
                                                                );
                                                            }}
                                                        />

                                                        {!values.filePdf
                                                            ?.name && (
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                <a
                                                                    style={{
                                                                        color: "#2C76AA",
                                                                        textDecoration: "underline",
                                                                    }}>
                                                                    + Upload Document
                                                                </a>
                                                            )}
                                                        <span className="upload-name">
                                                            {
                                                                values.filePdf
                                                                    ?.name
                                                            }
                                                        </span>
                                                    </label>
                                                </div>
                                                {errors.filePdf
                                                    ?.toString()
                                                    .includes("_") ? (
                                                    <div className="error">
                                                        Please select file size
                                                        less than{" "}
                                                        {+(
                                                            process.env
                                                                .REACT_APP_PDF_SIZE_LIMIT ||
                                                            4194304
                                                        ) / 1048576}
                                                        MB.
                                                    </div>
                                                ) : errors.filePdf
                                                    ?.toString()
                                                    .includes("+") ? (
                                                    <div className="error">
                                                        Please select PDF file.
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            {/* <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    In-Depth Industry Niches:{" "}
                                                    <span className="required">*</span>
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            List up to five in-depth industry niches your organization serves within the
                                                            specialized product area.
                                                        </i>
                                                    </span>
                                                </div>

                                                <AGTextarea
                                                    maxLength={254}
                                                    placeholder="Enter your answer"
                                                    className="text-area"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length <= 254) {
                                                            setFieldValue("comrelevantIndustry", e.target.value);
                                                        } else {
                                                            setFieldValue("comrelevantIndustry", e.target.value.slice(0, 254));
                                                        }
                                                    }}
                                                />
                                                {errors.comrelevantIndustry && (
                                                    <div className="error">
                                                        This question is
                                                        required.{" "}
                                                    </div>
                                                )}
                                            </div> */}
                                            {/* <label
                                                className="label-title"
                                                htmlFor="">
                                                Product Availability:
                                            </label>
                                            <div style={{
                                                borderRadius: "7px",
                                                padding: "0px 10px",
                                                border: "1px solid rgb(223, 228, 234)",
                                            }}>
                                                <label style={{ marginTop: 10, marginBottom: 20, display: "flex", gap: 10, alignItems: "start" }} className="flex items-center">
                                                    <AGCheckbox
                                                        value={values.acceptingClients}
                                                        onChange={(e) => {
                                                            setFieldValue("acceptingClients", !values.acceptingClients)
                                                        }} />
                                                    <div>
                                                        <span className="service-available-options">
                                                            Accepting client referrals from peer Allinial Global
                                                        </span>
                                                    </div>
                                                </label>
                                                <label style={{ marginBottom: 20, display: "flex", gap: 10, alignItems: "start" }} className="flex items-center">
                                                    <AGCheckbox
                                                        value={values.willingOfferAdvice}
                                                        onChange={(e) => {
                                                            setFieldValue("willingOfferAdvice", !values.willingOfferAdvice)
                                                        }} />
                                                    <div>
                                                        <span className="service-available-options">
                                                            Offer advice/share expertise
                                                        </span>
                                                    </div>
                                                </label>
                                                <label style={{ marginBottom: 20, display: "flex", gap: 10, alignItems: "start" }} className="flex items-center">
                                                    <AGCheckbox value={values.loanStaff}
                                                        onChange={(e) => {
                                                            setFieldValue("loanStaff", !values.loanStaff)
                                                        }} />
                                                    <div>
                                                        <span className="service-available-options">
                                                            Share talent to work on engagements & gain on-the-job training
                                                        </span>
                                                    </div>
                                                </label>
                                                <label style={{ marginBottom: 20, display: "flex", gap: 10, alignItems: "start" }} className="flex items-center">
                                                    <AGCheckbox
                                                        value={values.receiveStaff}
                                                        onChange={(e) => {
                                                            setFieldValue("receiveStaff", !values.receiveStaff)
                                                        }} />
                                                    <div>
                                                        <span className="service-available-options">
                                                            Host shared talent to work on engagements & offer on-the-job
                                                        </span>
                                                    </div>
                                                </label>
                                                <label style={{ marginBottom: 20, display: "flex", gap: 10, alignItems: "start" }} className="flex items-center">
                                                    <AGCheckbox value={values.globalOpportunities}
                                                        onChange={(e) => {
                                                            setFieldValue("globalOpportunities", !values.globalOpportunities)

                                                        }} />
                                                    <div>
                                                        <span className="service-available-options">
                                                            Offer international secondment opportunities through the Global Opportunities (GO) program?
                                                        </span>
                                                    </div>
                                                </label>
                                            </div> */}
                                            <div >
                                                <label className="label-title">
                                                    Member Benefits: <Tooltip text={<div className="tool-tip">Describe the specific benefits member organizations will receive (e.g. Discounts and other offerings).</div>} />
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            One or two simple sentences that are compelling and distill the member benefits within the specialized product area.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGTextarea
                                                    maxLength={255}
                                                    placeholder="Enter your answer"
                                                    className="text-area"
                                                    value={values.memberBenefits}
                                                    onChange={(e) => {
                                                        setFieldValue("memberBenefits", e.target.value)
                                                    }}
                                                />
                                            </div>
                                            {/* <label style={{ paddingTop: 10, marginBottom: 10, display: "flex", gap: 10, alignItems: "center" }} className="flex items-center">
                                                <AGCheckbox
                                                    className="custom-checkbox"
                                                    classNameCus="custom-checkbox-sponsorProfile"
                                                    value={values.sponsorProfile}
                                                    onChange={(e) => {
                                                        setFieldValue("sponsorProfile", !values.sponsorProfile)
                                                    }}
                                                />
                                                <div>
                                                    <span style={{ padding: 0 }} className="label-title">
                                                        Sponsor Profile
                                                    </span>
                                                </div>
                                            </label>
                                            {values.sponsorProfile && (
                                                <div style={{
                                                    borderRadius: "7px",
                                                    padding: "0px 10px",
                                                    border: "1px solid rgb(223, 228, 234)",
                                                    marginBottom: 10
                                                }}>
                                                    <div>
                                                        <div className="flex w-full gap-[15px]">
                                                            <div className="w-1/2">
                                                                <label className="label-title-cus">
                                                                    Start Date:
                                                                </label>
                                                                <StyledDatePickerCus
                                                                    isClearable
                                                                    className="react-datepicker-wrapper"
                                                                    selected={values.startDate || new Date()}
                                                                    onChange={(date: any) => {
                                                                        setFieldValue("startDate", date);
                                                                        setFieldValue("endDate", date);
                                                                        setSelectedDate(date);
                                                                    }}
                                                                    value={values.startDate ? values.startDate.toLocaleDateString() : ''}
                                                                    minDate={selectedDate ? selectedDate : new Date()}
                                                                />
                                                            </div>
                                                            <div className="w-1/2">
                                                                <label className="label-title-cus">
                                                                    End Date:
                                                                </label>
                                                                <StyledDatePickerCus
                                                                    isClearable
                                                                    className="react-datepicker-wrapper"
                                                                    selected={values.endDate ? values.endDate : selectedDate}
                                                                    onChange={(date: any) => {
                                                                        setFieldValue("endDate", date);
                                                                    }}
                                                                    value={values.endDate ? values.endDate.toLocaleDateString() : ''}
                                                                    minDate={selectedDate ? selectedDate : new Date()}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="w-full pb-[15px]">
                                                            <label className="label-title">
                                                                Sponsored Message:
                                                            </label>
                                                            <AGInput
                                                                maxLength={50}
                                                                placeholder="Enter your answer"
                                                                className="custom-input"
                                                                value={values.sponsorMessage}
                                                                onChange={(e) => {
                                                                    setFieldValue("sponsorMessage", e.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )} */}
                                            <RolesHandleAdmin firmId={ADMIN_ORGANIZATION.ID} fkOrgId={ADMIN_ORGANIZATION.ID} roles={["Admin"]}>
                                                <label style={{ paddingTop: 10, marginBottom: 10, display: "flex", gap: 10, alignItems: "center" }} className="flex items-center">
                                                    <AGCheckbox
                                                        className="custom-checkbox"
                                                        classNameCus="custom-checkbox-sponsorProfile"
                                                        value={values.sponsorProfile}
                                                        onChange={(e) => {
                                                            setFieldValue("sponsorProfile", !values.sponsorProfile)
                                                        }}
                                                    />
                                                    <div>
                                                        <span style={{ padding: 0 }} className="label-title">
                                                            Sponsor Profile
                                                        </span>
                                                    </div>
                                                </label>
                                                {values.sponsorProfile && (
                                                    <div style={{
                                                        borderRadius: "7px",
                                                        padding: "0px 10px",
                                                        border: "1px solid rgb(223, 228, 234)",
                                                        marginBottom: 10,
                                                        touchAction: "none"
                                                    }}>
                                                        <div>
                                                            <div className="flex w-full gap-[15px]">
                                                                <div className="w-1/2">
                                                                    <label className="label-title-cus touch-none">
                                                                        Start Date: <span className="required">*</span>
                                                                    </label>
                                                                    <AddIconDatePicker>
                                                                        <GlobalStyle/>
                                                                        <StyledDatePickerCus
                                                                            isClearable
                                                                            className="react-datepicker-wrapper"
                                                                            selected={values.startDate}
                                                                            onChange={(date: any) => {
                                                                                setFieldValue("startDate", date);
                                                                                if (values.endDate && new Date(date) >= new Date(values.endDate)) {
                                                                                    setFieldValue("endDate", undefined);
                                                                                }
                                                                                setSelectedDate(date);
                                                                            }}
                                                                            placeholderText="mm/dd/yyyy"
                                                                            value={values.startDate}
                                                                            popperPlacement="top-start"
                                                                            onKeyDown={handleNumericDateInput}
                                                                        />
                                                                    </AddIconDatePicker>
                                                                    {errors.startDate && (
                                                                        <div className="error">
                                                                            This question is
                                                                            required.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="w-1/2">
                                                                    <label className="label-title-cus touch-none">
                                                                        End Date: <span className="required">*</span>
                                                                    </label>
                                                                    <AddIconDatePicker>
                                                                        <StyledDatePickerCus
                                                                            isClearable
                                                                            className="react-datepicker-wrapper"
                                                                            selected={values.endDate}
                                                                            placeholderText="mm/dd/yyyy"
                                                                            onChange={(date: any) => {
                                                                                setFieldValue("endDate", date);
                                                                            }}
                                                                            value={values.endDate}
                                                                            popperPlacement="top-start"
                                                                            minDate={selectedDate ? moment(selectedDate).add(1, "day").toDate() : (selectedDate && values.startDate) ? values.endDate : undefined}
                                                                            onKeyDown={handleNumericDateInput}
                                                                        />
                                                                    </AddIconDatePicker>
                                                                    {errors.endDate && (
                                                                        <div className="error">
                                                                            This question is
                                                                            required.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="w-full pb-[15px]">
                                                                <label className="label-title touch-none">
                                                                    Sponsored Message: <span className="required">*</span>
                                                                </label>
                                                                <AGInput
                                                                    maxLength={50}
                                                                    placeholder="Enter your answer"
                                                                    className="custom-input"
                                                                    value={values.sponsorMessage}
                                                                    onChange={(e) => {
                                                                        setFieldValue("sponsorMessage", e.target.value)
                                                                    }}
                                                                />
                                                                {errors.sponsorMessage && (
                                                                    <div className="error">
                                                                        This question is
                                                                        required.
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </RolesHandleAdmin>
                                        </form>
                                    );
                                }}
                            </Formik>
                        </div>
                    </div>
                </CommerceCompassStyled>
            </CustomBackground>
        </AGModal >
    );
};
export default AddProductModal;


const PlusIcon = () => {
    return <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z" fill="#0971A2" />
    </svg>
}

const MinusIcon = () => {
    return <svg width={15} viewBox="0 0 24 24" fill="rgb(44, 118, 170)" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 12L18 12" stroke="rgb(44, 118, 170)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
}